<div id="activate-account" class="flex flex-col" fusePerfectScrollbar>
  <div id="activate-account-form-wrapper" class="flex flex-col items-center justify-center">
    <div id="activate-account-form" *fuseIfOnDom [@animate]="{ value: '*', params: { duration: '300ms', y: '100px' } }">
      <div class="logo">
        <mat-icon class="s-96">perm_phone_msg</mat-icon>
      </div>

      <div i18n class="title mb-4">Активация учетной записи</div>

      <mat-form-field appearance="outline">
        <mat-label i18n>Код подтверждения</mat-label>
        <input type="text" [formControl]="code" mask="0 0 0 0 0 0" matInput placeholder="0 0 0 0 0 0" />
        <mat-error i18n *ngIf="code.errors?.minlength || code.errors?.required || code.errors?.maxlength"
          >длина кода должна быть равна 6 символам</mat-error
        >
      </mat-form-field>

      <div>
        <button [disabled]="timeSec >= 0 || !clientId || !phone" mat-button>
          <span i18n>Отправить код еще раз</span>
          <span *ngIf="timeSec >= 0">( <span i18n>Через</span> {{ getMinutes(timeSec) }}:{{ timeSec % 60 }}) </span>
        </button>
      </div>

      <div i18n class="subtitle"
        >На номер {{ phone }} было отправлено SMS с кодом подтверждения. Для активации учетной записи введите код из
        SMS</div
      >

      <button
        i18n
        mat-raised-button
        [disabled]="code.invalid || !clientId || !phone"
        class="submit-button"
        color="accent"
        aria-label="SEND RESET LINK"
        (click)="sendSmsCode()"
        >ОТПРАВИТЬ</button
      >

      <div class="message" *ngIf="userId">
        <a i18n class="link" [routerLink]="['/client/auth/login']" [queryParams]="{ user: userId }"
          >Перейти на страницу авторизации</a
        >
      </div>
    </div>
  </div>
</div>
